import React, {FC, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {ErrorMessage, Field} from 'formik'
import getBroker from '../../../auth/components/server/Step8'
import {ICreateAccount, inits as initialValues} from '../CreateAccountWizardHelper'
import {showToast} from '../../../auth/components/middleware/showToast'
import {useLocation} from 'react-router-dom'

const OPTIONS_REFER = [
  {value: '1', text: 'Nhân viên/CTV'},
  {value: '2', text: 'Khách hàng'},
  {value: '3', text: 'Quảng cáo'},
  {value: '4', text: 'Khác'},
] as const

const BRANCH_OPTIONS = [
  {value: '100', text: 'Hội sở Hà Nội'},
  {value: '500', text: 'Hồ Chí Minh'},
] as const

const parseSearchParams = (search: string) => {
  const queryWithoutQuestionMark = search.slice(1)
  const pairs = queryWithoutQuestionMark.split('&')
  return pairs.reduce((result: Record<string, string>, pair) => {
    const [key, value] = pair.split('=')
    result[key] = value
    return result
  }, {})
}

const fetchBrokerInfo = async (empNo: string, branchCode: string) => {
  try {
    const res = await getBroker({
      emp_no: empNo,
      brch_cd: branchCode ? branchCode : undefined,
    })
    return res?.data_list[0]
  } catch (err) {
    console.error('Error fetching broker:', err)
    return null
  }
}

const Step8: FC<any> = ({
  isActive = true,
  setActiveStep,
  handleGetNameInfo,
  handleGetNameCare,
  setFieldValue,
  getFieldProps,
  errors,
}) => {
  const [selected, setSelected] = useState(OPTIONS_REFER[0].value)
  const [selectedTakecare, setSelectedTakecare] = useState('')
  const [nameBroker, setNameBroker] = useState('')
  const [nameBrokerCare, setNameBrokerCare] = useState('')
  const [openIntroduce, setOpenIntroduce] = useState(false)
  const data = initialValues
  const [validateId, setValidateId] = useState(false)
  const [validateIdCare, setValidateIdCare] = useState(false)
  const [getBranch, setGetBranch] = useState()
  const [getNameInfo, setGetNameInfo] = useState<string>('')
  const [getNameInfoCare, setGetNameInfoCare] = useState<string>('')
  const [getValUrlSearch, setGetValUrlSearch] = useState<any>()
  const [checkDisableMkt, setCheckDisableMkt] = useState(false)
  const [checkDisableMg, setCheckDisableMg] = useState(false)
  const location = useLocation()
  const [branchDisabled, setBranchDisabled] = useState(false)

  useEffect(() => {
    if (location.search) {
      const params = parseSearchParams(location.search)
      setGetValUrlSearch(params)
    }
  }, [location.search])

  const handleChangeRefer = (e: any) => {
    setSelected(e.target.value)
    setOpenIntroduce(true)
  }

  const handleTakecare = (e: any) => {
    if (e.target.value === 'N') {
      setValidateIdCare(false)
      setBranchDisabled(false)
    } else if (e.target.value === 'Y') {
      setActiveStep(true)
    }
    setSelectedTakecare(e.target.value)
  }

  const handleShowIdChange = (e: any) => {
    setActiveStep(true)
  }
  const handleShowIdCareChange = (e: any) => {
    setActiveStep(true)
  }

  const handleShowId = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const empNo = e.target.value
    setGetNameInfo(empNo)

    if (!empNo) {
      setNameBroker('')
      setValidateId(false)
      return
    }

    const branchCode = ''
    const brokerInfo = await fetchBrokerInfo(empNo, branchCode)

    if (brokerInfo?.code_nm) {
      setNameBroker(brokerInfo.code_nm)
      setValidateId(false)
    } else if (brokerInfo?.chk) {
      setActiveStep(true)
      setNameBroker('')
      setValidateId(true)
    }
  }

  const handleShowIdCare = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const empNo = e.target.value
    setGetNameInfoCare(empNo)

    if (!empNo) {
      setNameBrokerCare('')
      setValidateIdCare(false)
      setBranchDisabled(false)
      return
    }

    // Try Hanoi branch first
    const hanoiBroker = await fetchBrokerInfo(empNo, '100')
    if (hanoiBroker?.code_nm) {
      setNameBrokerCare(hanoiBroker.code_nm)
      setValidateIdCare(false)
      setFieldValue('brch_cd', '100')
      setBranchDisabled(true)
      return
    }

    // Try HCM branch if not found in Hanoi
    const hcmBroker = await fetchBrokerInfo(empNo, '500')
    if (hcmBroker?.code_nm) {
      setNameBrokerCare(hcmBroker.code_nm)
      setValidateIdCare(false)
      setFieldValue('brch_cd', '500')
      setBranchDisabled(true)
      return
    }

    // If not found in either branch
    setActiveStep(true)
    setNameBrokerCare('')
    setValidateIdCare(true)
    setBranchDisabled(false)
  }

  const handleSelectChange = async (val: any) => {
    setGetBranch(val.target.value)
    if (selectedTakecare && selectedTakecare === 'Y') {
      await fetchBrokerInfo(getNameInfoCare, getValUrlSearch?.branchCd || val.target.value)
        .then((res) => {
          if (res?.code_nm) {
            setNameBrokerCare(res.code_nm)
            setValidateIdCare(false)
            setActiveStep(false)
          } else if (res?.chk) {
            setActiveStep(true)
            setNameBrokerCare('')
            setValidateIdCare(true)
          }
        })
        .catch((err) => {
          console.log('err: ', err)
          setValidateIdCare(false)
        })
    }
    if (!getNameInfo || selectedTakecare) {
      return
    }
  }

  useEffect(() => {
    if (getValUrlSearch) {
      getValUrlSearch
        ? setFieldValue('brch_cd', getValUrlSearch?.branchCd)
        : setFieldValue('brch_cd', data.brch_cd)
    }
  }, [data.brch_cd, getValUrlSearch, setFieldValue])

  useEffect(() => {
    if (selected) {
      if (selected === '1' || selected === '2' || selected === '3' || selected === '4') {
        setValidateId(false)
        setFieldValue('ifno_idno', '')
        setNameBroker('')
      }
    }
  }, [data.ifno_idno, selected, setFieldValue])

  useEffect(() => {
    if (selectedTakecare === 'N') {
      setNameBrokerCare('')
      setFieldValue('mng_emp_no', '')
    }
  }, [getValUrlSearch, selectedTakecare, setFieldValue])

  // Tính lại trạng thái nút "Tiếp theo" mỗi khi step này được mở (kể cả khi quay lại từ
  // step 7/9), vì component không unmount nên các dependency khác có thể không đổi.
  useEffect(() => {
    if (!isActive) {
      return
    }

    const temp =
      !errors?.brch_cd &&
      !errors?.sms_tp &&
      !errors?.rcm_emp_no_tp &&
      !errors?.ifno_idno &&
      !errors?.mng_emp_yn &&
      !validateId &&
      !validateIdCare
    if (selected && selectedTakecare) {
      if (selected === '1' && selectedTakecare === 'Y') {
        setActiveStep(true)
        if (nameBroker && nameBrokerCare) {
          temp && setActiveStep(false)
        }
      }
      if (selected === '1' && selectedTakecare === 'N') {
        setActiveStep(true)
        if (nameBroker) {
          temp && setActiveStep(false)
        }
      }
      if (selected !== '1' && selectedTakecare === 'Y') {
        setActiveStep(true)
        if (nameBrokerCare) {
          temp && setActiveStep(false)
        }
      }
      if (selected !== '1' && selectedTakecare === 'N') {
        temp && setActiveStep(false)
      }
    }
  }, [
    errors?.brch_cd,
    errors?.ifno_idno,
    errors?.mng_emp_yn,
    errors?.rcm_emp_no_tp,
    errors?.sms_tp,
    nameBroker,
    nameBrokerCare,
    selected,
    selectedTakecare,
    setActiveStep,
    validateId,
    validateIdCare,
    isActive,
  ])

  useEffect(() => {
    handleGetNameInfo(nameBroker)
  }, [handleGetNameInfo, nameBroker])

  useEffect(() => {
    handleGetNameCare(nameBrokerCare)
  }, [handleGetNameCare, nameBrokerCare])

  useEffect(() => {
    if (getValUrlSearch) {
      fetchBrokerInfo(getValUrlSearch?.idBroker, getValUrlSearch?.branchCd)
        .then((res) => {
          if (res?.code_nm) {
            if (getValUrlSearch.type === 'mkt') {
              setNameBroker(res.code_nm)
            } else if (getValUrlSearch.type === 'mg') {
              setNameBrokerCare(res.code_nm)
            } else if (getValUrlSearch.type === 'all') {
              setNameBroker(res.code_nm)
              setNameBrokerCare(res.code_nm)
            }
          }
        })
        .catch((err) => {
          console.log('err: ', err)
          showToast('Liên hệ Admin', 1500, 'error')
        })
    }
  }, [getValUrlSearch])

  useEffect(() => {
    if (getValUrlSearch) {
      if (getValUrlSearch.type === 'mkt') {
        setCheckDisableMkt(true)
        setSelected('1')
        setFieldValue('rcm_emp_no_tp', '1')
        setFieldValue('ifno_idno', getValUrlSearch.idBroker)
        setOpenIntroduce(true)
      }
      if (getValUrlSearch.type === 'mg') {
        setCheckDisableMg(true)
        setFieldValue('mng_emp_yn', 'Y')
        setSelectedTakecare('Y')
        setFieldValue('mng_emp_no', getValUrlSearch.idBroker)
      }
      if (getValUrlSearch.type === 'all') {
        setCheckDisableMkt(true)
        setCheckDisableMg(true)
        setSelected('1')
        setFieldValue('rcm_emp_no_tp', '1')
        setFieldValue('ifno_idno', getValUrlSearch.idBroker)
        setOpenIntroduce(true)
        setFieldValue('mng_emp_yn', 'Y')
        setSelectedTakecare('Y')
        setFieldValue('mng_emp_no', getValUrlSearch.idBroker)
      }
    }
  }, [getValUrlSearch, setFieldValue])

  return (
    <div className='w-100'>
      <div className='w-100'>
        <div className='pb-5 pb-lg-5'>
          <h2 className='fw-bolder text-primary text-center'>Đăng ký dịch vụ bổ sung</h2>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Loại tài khoản</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' checked />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>Thông thường</span>
                </span>
              </span>
            </label>
            <label className='form-check form-check-inline form-check-solid me-5 d-block'>
              <Field className='form-check-input' type='checkbox' name='acnt_mrgn_tp' />
              <span className='text-gray-800 ps-2 fs-5'>Ký quỹ (Margin)</span>
            </label>

            <label className='form-check form-check-inline form-check-solid me-5 mt-5 d-block'>
              <Field className='form-check-input' type='checkbox' name='acnt_dr_tp' />
              <span className='text-gray-800 ps-2 fs-5'>Phái sinh</span>
            </label>
          </div>
          <div className='text-danger mt-2'>
            <ErrorMessage component='span' name='acnt_mrgn_tp' />
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>Giao dịch trực tuyến</label>
            <div className='d-flex align-items-center'>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  className='form-check-input w-45px h-30px'
                  type='checkbox'
                  disabled
                  name='trd_onl_yn'
                />
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>Phương thức xác thực: OTP</label>
            <div className='d-flex align-items-center'>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  className='form-check-input w-45px h-30px'
                  type='checkbox'
                  disabled
                  name='cert_tp'
                />
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>Phương thức nhận thẻ OTP: Email</label>
            <div className='d-flex align-items-center'>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  className='form-check-input w-45px h-30px'
                  type='checkbox'
                  disabled
                  name='otp_recv_tp'
                />
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3 d-flex justify-content-between'>
            <label className='fs-6 fw-bold form-label'>Ứng trước tiền bán chứng khoán</label>
            <div className='d-flex align-items-center'>
              <div className='form-check form-check-solid form-switch fv-row'>
                <Field
                  className='form-check-input w-45px h-30px'
                  type='checkbox'
                  name='auto_pia_tp'
                />
                <label className='form-check-label'></label>
              </div>
            </div>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Phương thức nhận thông báo</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='sms_tp' value='1' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>SMS cơ bản</span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='sms_tp' value='2' />
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>SMS nâng cao</span>
                </span>
              </span>
            </label>
            <div className='text-danger mt-2'>
              <ErrorMessage component='span' name='sms_tp' />
            </div>
            <label className='form-check form-check-inline form-check-solid me-5 text-hover-primary'>
              <Field className='form-check-input' type='checkbox' name='email_yn' />
              <span className='fw-bold ps-2 fs-6'>Email</span>
            </label>
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Người giới thiệu</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2' style={{width: '100%'}}>
                <span
                  className='form-check form-check-custom form-check-solid'
                  style={{width: '100%'}}
                >
                  <Field
                    as='select'
                    className='form-select form-select-lg form-select-solid'
                    name='rcm_emp_no_tp'
                  >
                    {({field, form: {touched, errors}}: any) => (
                      <select
                        className={`form-select form-select-lg form-select-solid ${
                          checkDisableMkt ? 'noactive' : ''
                        }`}
                        {...field}
                        disabled={checkDisableMkt}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          let newEvent = e
                          handleChangeRefer(newEvent)
                          return field.onChange(newEvent)
                        }}
                      >
                        <option value='' disabled>
                          Chọn người giới thiệu
                        </option>
                        {OPTIONS_REFER.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.text}
                          </option>
                        ))}
                        {touched[field.name] && errors[field.name] && (
                          <div className='error'>{errors[field.name]}</div>
                        )}
                      </select>
                    )}
                  </Field>
                </span>
              </span>
            </label>
            <div className='text-danger mt-2'>
              <ErrorMessage component='span' name='rcm_emp_no_tp' />
            </div>

            {openIntroduce && selected === '1' && (
              <div>
                <Field
                  name='ifno_idno'
                  placeholder='ID Nhân viên/CTV *'
                  className='form-control form-control-lg form-control-solid'
                >
                  {({field, form, meta}: any) => (
                    <input
                      className={`form-control form-control-lg form-control-solid ${
                        checkDisableMkt ? 'noactive' : ''
                      }`}
                      {...field}
                      disabled={checkDisableMkt}
                      placeholder='ID Nhân viên/CTV *'
                      onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        handleShowId(newEvent)
                        return field.onChange(newEvent)
                      }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        handleShowIdChange(newEvent)
                        return field.onChange(newEvent)
                      }}
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Enter') {
                          handleShowId(e as any)
                        }
                      }}
                    />
                  )}
                </Field>
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='ifno_idno' />
                </div>
                {validateId ? (
                  <div className='text-danger mt-2'>
                    Không tồn tại nhân viên môi giới ở chi nhánh Quý khách mở tài khoản
                  </div>
                ) : null}
                <div className='mt-4'>
                  <Field
                    disabled
                    className='form-control form-control-lg noactive'
                    placeholder='Tên người giới thiệu'
                    value={nameBroker ?? null}
                  />
                </div>
              </div>
            )}
            {openIntroduce && selected !== '1' && (
              <div>
                <Field
                  name='ifno_idno'
                  placeholder={selected === '2' ? 'Nhập CMND/CCCD *' : 'Nhập thông tin *'}
                  className='form-control form-control-lg form-control-solid'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='ifno_idno' />
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='mb-10 fv-row border p-4 rounded'>
          <div className='mt-3'>
            <label className='fs-6 fw-bold form-label'>Nhân viên chăm sóc tài khoản</label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='mng_emp_yn' value='N'>
                    {({field, form: {touched, errors}}: any) => (
                      <input
                        className='form-check-input'
                        {...field}
                        disabled={checkDisableMg}
                        type='radio'
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          let newEvent = e
                          handleTakecare(newEvent)
                          return field.onChange(newEvent)
                        }}
                      />
                    )}
                  </Field>
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>
                    Tôi không có nhu cầu
                  </span>
                </span>
              </span>
            </label>
            <label className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='form-check form-check-custom form-check-solid'>
                  <Field className='form-check-input' type='radio' name='mng_emp_yn' value='Y'>
                    {({field, form: {touched, errors}}: any) => (
                      <input
                        className='form-check-input'
                        {...field}
                        type='radio'
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          let newEvent = e
                          handleTakecare(newEvent)
                          return field.onChange(newEvent)
                        }}
                      />
                    )}
                  </Field>
                </span>
                <span className='d-flex flex-column mx-4'>
                  <span className='text-gray-800 text-hover-primary fs-5'>
                    Tôi đã có nhân viên chăm sóc
                  </span>
                </span>
              </span>
            </label>
            <div className='text-danger mt-2'>
              <ErrorMessage component='span' name='mng_emp_yn' />
            </div>
            {selectedTakecare === 'Y' ? (
              <div>
                <Field
                  name='mng_emp_no'
                  placeholder='ID Nhân viên *'
                  className='form-control form-control-lg form-control-solid'
                  render={({field, form: {touched, errors}}: any) => (
                    <input
                      className={`form-control form-control-lg form-control-solid ${
                        checkDisableMg ? 'noactive' : ''
                      }`}
                      placeholder='ID Nhân viên/CTV *'
                      {...field}
                      disabled={checkDisableMg}
                      onBlur={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        handleShowIdCare(newEvent)
                        return field.onChange(newEvent)
                      }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        handleShowIdCareChange(newEvent)
                        return field.onChange(newEvent)
                      }}
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        if (e.key === 'Enter') {
                          handleShowIdCare(e as any)
                        }
                      }}
                    />
                  )}
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage component='span' name='mng_emp_no' />
                </div>

                {validateIdCare ? (
                  <div className='text-danger mt-2'>
                    Không tồn tại nhân viên môi giới ở chi nhánh Quý khách mở tài khoản
                  </div>
                ) : null}
                <div className='mt-4'>
                  <Field
                    disabled
                    className='form-control form-control-lg noactive'
                    placeholder='Tên nhân viên chăm sóc'
                    value={nameBrokerCare ?? null}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='form-label'>Chi nhánh NHSV gần với vị trí của bạn nhất</label>

          <Field
            as='select'
            name='brch_cd'
            className='form-select form-select-lg form-select-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <select
                className={`form-select form-select-lg form-select-solid ${
                  checkDisableMkt || checkDisableMg || branchDisabled ? 'noactive' : ''
                }`}
                {...field}
                disabled={checkDisableMkt || checkDisableMg || branchDisabled}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  let newEvent = e
                  handleSelectChange(newEvent)
                  return field.onChange(newEvent)
                }}
              >
                <option value='' disabled>
                  Chọn tên chi nhánh
                </option>
                {BRANCH_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.text}
                  </option>
                ))}
                {touched[field.name] && errors[field.name] && (
                  <div className='error'>{errors[field.name]}</div>
                )}
              </select>
            )}
          </Field>
          <div className='text-danger mt-2'>
            <ErrorMessage component='span' name='brch_cd' />
          </div>
        </div>
      </div>
    </div>
  )
}

export {Step8}
